import React from 'react';
import { getGlobalData } from './globalData';
import List from "@mui/material/List";
import { useSidebarState } from 'react-admin';

import NestableMenuList from './NestableMenuList';
import {MenuConext} from './MenuContext';

//https://materialdesignicons.com

function nestResources(resources, onMenuClick, dense, classes) {
  var menu = getGlobalData('menu');
  
  return (
    <div>
      <MenuConext.Consumer>
        {(ct) => {
          return (
            <NestableMenuList list={menu} menuct={ct} onMenuClick={onMenuClick} dense={dense} sub={false} />
          )}}
      </MenuConext.Consumer>
    </div>
  );
}

const MyMenu = ({
    hasDashboard,
    onMenuClick,
    open,
    pathname,
    resources,
    translate,
    logout,
    ...rest
}) => {
  const [sbopen] = useSidebarState();
  return (
    <div>
      { !sbopen && <img src="favicon_bookworld_24x24px_rgb.svg" style={{ marginLeft: '.5em', width:"80%"}} alt="Logo" /> }
      { sbopen && <img src="/logo.svg" style={{width:"100%"}} alt="Logo" /> }
      <List {...rest}>
        {nestResources(resources, onMenuClick, sbopen)}            
      </List>
    </div>
)};

/*          <Responsive xsmall={logout} medium={null} /> */

export default MyMenu;
